import React, { useEffect, useMemo, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper, Select, MenuItem,
    useMediaQuery, Button, TextareaAutosize, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Checkbox
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import Titlebar from '../TitleBar';
import { materialPOMenu } from '../TitleList';
import styled, { inputImages, inputStyles } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentDate } from '../../Utils/Dateutils';
import { fetchAllPONumbers, fetchMaterialPOReg, fetchPOData } from '../../Store/PHPSlice/Purchase/PoNo';
import { selectAllPONumbers, selectFirm, selectlocationdata, selectParty, selectPINos, selectPOData, selectRack, selectTransports } from '../Selectors/Master/ItemSelectors';
import { fetchLocationData, fetchTransportData } from '../../Store/PHPSlice/Transport';
import { createPurInwEntry, fetchPINo } from '../../Store/PHPSlice/Inward/PurchaseInward';
import { fetchRackData } from '../../Store/PHPSlice/Rack';
import Dropdown from '../FieldsComponents/Dropdown';
import CircularProgress from '@mui/material/CircularProgress';
import axios from 'axios';
import { selectMaterialPOReg } from '../Selectors/Master/OutwardSelectors';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';
import { fetchPartyData } from '../../Store/PHPSlice/Party';
import { fetchCompanyData } from '../../Store/PHPSlice/Firm';


const DirectMatPIEntry = () => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [formData, setFormData] = useState({
        dt: getCurrentDate(),
        tQtyM: '',
        PoId: '',
        firmId: '',
        amt: '',
        PiNo: '',
        vender: '',
        partyId: '',
        taxAmt: '',
        fAmt: '',
        lrdt: '',
        lrno: '',
        transpt: '',
        bill: '',
        locId: '',
        userId: userdata?.ID
    });
    const [tableRows, setTableRows] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(null);
    const [openBale, setOpenBale] = useState(false);
    const [noOfBales, setNoOfBales] = useState(0);
    const [rows, setRows] = useState([]);

    const [loading, setLoading] = useState(false);
    const [mpolist, setMpolist] = useState([]);
    const [materialData, setMaterialData] = useState([]);


    const dispatch = useDispatch();
    const polist = useSelector(selectPOData);
    const transptList = useSelector(selectTransports);
    const onlyPonos = useSelector(selectAllPONumbers);
    const PiNo = useSelector(selectPINos);
    const racklist = useSelector(selectRack);
    const loclist = useSelector(selectlocationdata);

    const mpodata = useSelector(selectMaterialPOReg);
    const partyList = useSelector(selectParty);
    const firmList = useSelector(selectFirm);
    // console.log(mpodata);

    useEffect(() => {
        dispatch(fetchPOData());
        dispatch(fetchTransportData());
        dispatch(fetchAllPONumbers());
        dispatch(fetchPINo());
        dispatch(fetchRackData());
        dispatch(fetchLocationData());
        fetchPiNoForMemo();
        fetchPONOForPIEntry();
        fetchMateriallist();
        dispatch(fetchPartyData());
        dispatch(fetchCompanyData());
    }, [dispatch]);


    useEffect(() => {
        if (mpodata?.common_data) {
            // console.log(mpodata);
            setTableRows(mpodata.common_data);
        }
        if (mpodata?.data) {
            const obj = mpodata?.data;
            const { ID, amt, date, dt, finalamt, firmId, firmNm, insts, partyId, partyNm, pono, refer, taxamt, totmtr, totqty } = obj;
            setFormData(prev => ({
                ...prev,
                // totamt: amt,
                // finalamt,
                firmNm,
                partyNm,
                pono,
                refer,
                // taxamt,
                // totmtr,
                // totqty,
                firmId,
                partyId,

            }));
        }
    }, [mpodata]);

    // useEffect(() => {
    //     const totalinwqty = tableRows.reduce(
    //         (sum, r) => sum + Number(r.inwqty || 0),
    //         0
    //     );
    //     const totamt = tableRows.reduce(
    //         (sum, r) => sum + Number(r.inwamt || 0),
    //         0
    //     );
    //     const totinwmtr = tableRows.reduce(
    //         (sum, r) => sum + Number(r.inwmtr || 0),
    //         0
    //     );
    //     const igst = tableRows.reduce(
    //         (sum, r) => sum + Number(r.igstamt || 0),
    //         0
    //     );
    //     const cgst = tableRows.reduce(
    //         (sum, r) => sum + Number(r.cgstamt || 0),
    //         0
    //     );
    //     const sgst = tableRows.reduce(
    //         (sum, r) => sum + Number(r.sgstamt || 0),
    //         0
    //     );
    //     const taxamt = totamt > 0 && (igst + cgst + sgst).toFixed(2);
    //     const finalamt = totamt > 0 && (Number(totamt) + Number(taxamt));

    //     setFormData(prev => ({
    //         ...prev,
    //         totqty: totalinwqty,
    //         totmtr: totinwmtr,
    //         totamt: totamt,
    //         taxamt: taxamt,
    //         finalamt: finalamt
    //     }));

    // }, [tableRows]);


    const fetchMateriallist = async () => {
        try {
            const res = await axios.get(`${baseUrl}?apicall=getMaterialListInfo`);
            // console.log(res.data);
            const data = res.data?.data;
            setMaterialData(data);
        } catch (error) {
            console.error(error);
        }
    };

    const fetchPONOForPIEntry = async () => {
        try {
            const res = await axios.get(`${baseUrl}?apicall=getMaterialPO_nosForPIEntry`);
            // console.log(res.data);
            setMpolist(res.data);
        } catch (error) {
            console.error(error);
        }
    };

    const fetchPiNoForMemo = async () => {
        try {
            const res = await axios.get(`${baseUrl}?apicall=getMaterialPiNo_api`);
            // console.log(res.data);
            const value = res.data?.data;

            setFormData((prevFormData) => ({
                ...prevFormData,
                PiNo: value.piNo
            }));
        } catch (error) {
            console.error(error);
        }
    };

    // console.log(formData.PoId);

    // useEffect(() => {
    //     if (formData.PoId) {
    //         const selectPos = polist?.data?.filter(item => item.ID === formData.PoId);
    //         // console.log(selectPos);

    //         if (selectPos.length > 0) {
    //             const newData = selectPos
    //                 .filter(selectPo => parseFloat(selectPo.balMtr) > 0) // only include balMtr > 0
    //                 .map(selectPo => ({
    //                     netAmt: parseFloat(selectPo.Amount) + parseFloat(selectPo.igstAmt) + parseFloat(selectPo.cgstamt) + parseFloat(selectPo.sgstAmt),
    //                     poInfoId: selectPo.poInfoId,
    //                     cloth: selectPo.cloth,
    //                     clothId: selectPo.clothId,
    //                     rate: selectPo.rate,
    //                     qty: selectPo.balMtr,
    //                     inwQty: selectPo.balMtr,
    //                     balQty: '0',
    //                     amount: selectPo.Amount,
    //                     IGST: selectPo.igst,
    //                     CGST: selectPo.cgst,
    //                     SGST: selectPo.sgst,
    //                     IGSTAmt: selectPo.igstAmt,
    //                     CGSTAmt: selectPo.cgstAmt,
    //                     SGSTAmt: selectPo.sgstAmt,
    //                     bale: [],
    //                     details: '',
    //                     bcolor: '',
    //                     poNo: selectPo?.poNo,
    //                     poId: selectPo?.ID
    //                 }));


    //             setTableRows(newData);

    //             const firstPo = selectPos[0];
    //             setFormData(prevFormData => ({
    //                 ...prevFormData,
    //                 tQtyM: firstPo.tot_mtr,
    //                 amt: firstPo.amt,
    //                 taxAmt: firstPo.taxAmt,
    //                 fAmt: firstPo.finalAmt,
    //                 vender: firstPo.partyNm,
    //                 partyId: firstPo.partyId,
    //                 firmId: firstPo.firmId
    //             }));
    //         } else {
    //             setTableRows([]);
    //         }
    //     }
    // }, [formData.PoId, polist.data]);


    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData(prevFormData => ({
            ...prevFormData,
            [dropdownType]: value
        }));
        // if (dropdownType === 'PoId') {
        //     dispatch(fetchMaterialPOReg(value));
        // }

        if (dropdownType === 'matId' && value) {
            const selectMat = materialData?.find(i => i.ID === value);
            if (selectMat) {
                // console.log(selectMat);
                const { ID, hsn, description, locId, locNm, materialNm, mtype, ptype, packetqty, mqty, size, totqty } = selectMat;
                handleAddMaterial(ID, materialNm, hsn, mtype, mqty, size, ptype, packetqty);
            }
            setTimeout(() => {
                setFormData({
                    ...formData,
                    cloth: ''
                });
            }, 1000);
        }
    };


    // const handleAddMaterial = (ID, materialNm, hsn, mtype, mqty, size, ptype, packetqty) => {

    //     const newRow = {
    //         matId: ID,
    //         materialNm: materialNm,
    //         size: size,
    //         hsn: hsn,
    //         packets: packetqty,
    //         mtype: mtype,
    //         ptype: ptype,
    //         packetqty: mqty,
    //         deliveryDate: '',
    //         inches: '',
    //         mtr: '0',
    //         totboxqty: 0,
    //         qty: '0',
    //         rate: '0',
    //         amount: '0',
    //         IGST: '5',
    //         IGSTAmt: '0',
    //         CGST: '2.5',
    //         CGSTAmt: '0',
    //         SGST: '2.5',
    //         SGSTAmt: '0'
    //     };
    //     setTableRows([...tableRows, newRow]);
    // };
const calculateTotals = (rows) => {

    const totalMeter = rows.reduce((sum, r) => sum + Number(r.mtr || 0), 0);
    const totalQty = rows.reduce((sum, r) => sum + Number(r.totboxqty || 0), 0);
    const totalAmount = rows.reduce((sum, r) => sum + Number(r.amount || 0), 0);

    const igst = rows.reduce((sum, r) => sum + Number(r.IGSTAmt || 0), 0);
    const cgst = rows.reduce((sum, r) => sum + Number(r.CGSTAmt || 0), 0);
    const sgst = rows.reduce((sum, r) => sum + Number(r.SGSTAmt || 0), 0);

    const taxAmount = igst + cgst + sgst;
    const finalAmount = totalAmount + taxAmount;

    setFormData(prev => ({
        ...prev,
        totmtr: totalMeter.toFixed(2),
        totqty: totalQty.toFixed(2),
        totamt: totalAmount.toFixed(2),
        taxamt: taxAmount.toFixed(2),
        finalamt: finalAmount.toFixed(2)
    }));
};
    const handleAddMaterial = (ID, materialNm, hsn, mtype, mqty, size, ptype, packetqty) => {

    const newRow = {
        matId: ID,
        materialNm: materialNm,
        size: size,
        hsn: hsn,
        packets: packetqty,
        mtype: mtype,
        ptype: ptype,
        packetqty: mqty,
        deliveryDate: '',
        inches: 0,
        mtr: 0,
        totboxqty: 0,
        qty: 0,
        rate: 0,
        amount: 0,
        IGST: 5,
        IGSTAmt: 0,
        CGST: 2.5,
        CGSTAmt: 0,
        SGST: 2.5,
        SGSTAmt: 0
    };

    const updatedRows = [...tableRows, newRow];

    setTableRows(updatedRows);

    calculateTotals(updatedRows);
};
    const handleDateChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevFormData => ({
            ...prevFormData,
            [name]: value
        }));
    };


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevFormData => ({
            ...prevFormData,
            [name]: value.toUpperCase()
        }));
    };

    const handleRowInputChange = (index, e) => {
        const { name, value } = e.target;

        const newRows = [...tableRows];
        newRows[index][name] = value;
        // console.log(name, value)
        if ( name === 'qty' || name === 'amount' || name === 'IGST' ||
            name === 'IGSTAmt' || name === 'CGST' || name === 'CGSTAmt' || name === 'SGST' ||
            name === 'SGSTAmt') {
            if (!/^\d*$/.test(value)) {
                return;
            }
        }
        // Calculate amount if 'rate' or 'meter' changes
        // Calculate IGSTAmt based on state_type and IGST percentage

        // state type =
        //  inside - 0
        // outside - 1
        if (formData.vender !== '') {
            if (name === 'rate' || name === 'qty' || name === 'packets' || name === 'packetqty') {
                const rate = parseFloat(newRows[index]['rate']) || 0;
                const qty = parseFloat(newRows[index]['qty']) || 0;
                const packets = parseFloat(newRows[index]['packets']) || 0;
                const packetqty = parseFloat(newRows[index]['packetqty']) || 0;

                // Calculate CGST and SGST amounts based on amount
                const amount = parseFloat(newRows[index]['amount']) || 0;
                const CGSTPercent = parseFloat(newRows[index]['CGST']) || 0;
                const SGSTPercent = parseFloat(newRows[index]['SGST']) || 0;
                newRows[index]['CGSTAmt'] = ((amount * CGSTPercent) / 100).toFixed(2);
                newRows[index]['SGSTAmt'] = ((amount * SGSTPercent) / 100).toFixed(2);
                const mtype = newRows[index]['mtype'];


                if (mtype === "Pcs") {
                    newRows[index]['inches'] = 0;
                    newRows[index]['mtr'] = 0;

                    const singlebox = (packets * packetqty).toFixed(2);

                    newRows[index]['totboxqty'] = (qty * singlebox).toFixed(2);
                    newRows[index]['amount'] = (rate * qty).toFixed(2);
                }

                if (mtype === "Mtr") {
                    const inches = 39.3701; // 1mtr
                    const singleMtr = (packets * packetqty).toFixed(2);
                    const totmtr = (singleMtr * qty).toFixed(2);
                    newRows[index]['mtr'] = totmtr;
                    newRows[index]['inches'] = (totmtr * inches).toFixed(2);
                    newRows[index]['amount'] = (rate * qty).toFixed(2);
                    newRows[index]['totboxqty'] = 0;
                }

                if (mtype === "Inch") {
                    const inches = 39.3701; // 1mtr
                    const singleInchM = (packets * packetqty).toFixed(2);
                    const totinches = (singleInchM * qty).toFixed(2);
                    newRows[index]['inches'] = totinches;
                    newRows[index]['mtr'] = (totinches / inches).toFixed(2);
                    newRows[index]['amount'] = (rate * qty).toFixed(2);
                    newRows[index]['totboxqty'] = 0;
                }
            }
            const stateType = partyList.data.length > 0 ? partyList.data.find((item) => item.ID === formData.vender) : '';

            if (stateType.state_type === '1' || name === 'IGST' || name === 'amount') {
                const amount = parseFloat(newRows[index]['amount']) || 0;
                const IGSTPercent = parseFloat(newRows[index]['IGST']) || 0;
                newRows[index]['IGSTAmt'] = ((amount * IGSTPercent) / 100).toFixed(2);
                newRows[index]['CGSTAmt'] = '0';
                newRows[index]['SGSTAmt'] = '0';

                var totalTaxAmt = newRows.reduce((total, row) => total + parseFloat(row.IGSTAmt || 0), 0);
            }

            if (stateType.state_type === '0' || name === 'amount' || name === 'CGST' || name === 'SGST') {
                const amount = parseFloat(newRows[index]['amount']) || 0;
                const CGSTPercent = parseFloat(newRows[index]['CGST']) || 0;
                const SGSTPercent = parseFloat(newRows[index]['SGST']) || 0;

                newRows[index]['CGSTAmt'] = ((amount * CGSTPercent) / 100).toFixed(2);
                newRows[index]['SGSTAmt'] = ((amount * SGSTPercent) / 100).toFixed(2);
                newRows[index]['IGSTAmt'] = '0';

                var cgst1 = newRows.reduce((total, row) => total + parseFloat(row.CGSTAmt || 0), 0);
                var sgst1 = newRows.reduce((total, row) => total + parseFloat(row.SGSTAmt || 0), 0);
                var totalTaxAmt = cgst1 + sgst1;
            }
            if (name === 'amount' || name === 'CGST' || name === 'SGST') {
                const amount = parseFloat(newRows[index]['amount']) || 0;
                const CGSTPercent = parseFloat(newRows[index]['CGST']) || 0;
                const SGSTPercent = parseFloat(newRows[index]['SGST']) || 0;

                newRows[index]['CGSTAmt'] = ((amount * CGSTPercent) / 100).toFixed(2);
                newRows[index]['SGSTAmt'] = ((amount * SGSTPercent) / 100).toFixed(2);
                newRows[index]['IGSTAmt'] = '0';

                var cgst = newRows.reduce((total, row) => total + parseFloat(row.CGSTAmt || 0), 0);
                var sgst = newRows.reduce((total, row) => total + parseFloat(row.SGSTAmt || 0), 0);
                var totalTaxAmt = cgst + sgst;
            }

            if (name === 'IGST') {
                console.log(value);
                const amount = parseFloat(newRows[index]['amount']) || 0;
                const percentage = parseFloat(value);
                newRows[index]['IGST'] = percentage;

                if (stateType.state_type === '0') {
                    const halfPer = percentage / 2;
                    newRows[index]['CGST'] = halfPer;
                    newRows[index]['SGST'] = halfPer;

                    newRows[index]['CGSTAmt'] = ((amount * halfPer) / 100).toFixed(2);
                    newRows[index]['SGSTAmt'] = ((amount * halfPer) / 100).toFixed(2);
                    newRows[index]['IGSTAmt'] = '0';

                    var cgst = newRows.reduce((total, row) => total + parseFloat(row.CGSTAmt || 0), 0);
                    var sgst = newRows.reduce((total, row) => total + parseFloat(row.SGSTAmt || 0), 0);
                    var totalTaxAmt = cgst + sgst;
                } else {
                    newRows[index]['IGSTAmt'] = ((amount * percentage) / 100).toFixed(2);
                    newRows[index]['CGSTAmt'] = '0';
                    newRows[index]['SGSTAmt'] = '0';

                    var totalTaxAmt = newRows.reduce((total, row) => total + parseFloat(row.IGSTAmt || 0), 0);
                }
            }

            // const totalMeter = newRows.reduce((total, row) => total + parseFloat(row.mtr || 0), 0);
            // const totqty = newRows.reduce((total, row) => total + parseFloat(row.totboxqty || 0), 0);
            // const totalAmount = newRows.reduce((total, row) => total + parseFloat(row.amount || 0), 0);
            // const finalAmt = totalTaxAmt + totalAmount;

            // const updatedFormData = {
            //     ...formData,
            //     amt: totalAmount.toFixed(2),
            //     totmtr: totalMeter.toFixed(2),
            //     totqty: totqty.toFixed(2),
            //     taxAmt: totalTaxAmt.toFixed(2),
            //     fAmt: finalAmt.toFixed(2)
            // };

            // Update tableRows state
          //  setTableRows(newRows);
            // Update formData state
           // setFormData(updatedFormData);
           setTableRows(newRows);
            calculateTotals(newRows);
        } else {
            alert("Purchase Party Is required.");
        }
    };



    const handleCheckboxChange = (index) => {
        setSelectedRows(prevSelectedRows => {
            if (prevSelectedRows.length === 1 && prevSelectedRows[0] === index) {
                // If the checkbox to be deselected is the only selected one, deselect it
                return [];
            } else {
                // Deselect all other checkboxes and select the current one
                return [index];
            }
        });
    };

    // const handleCheckboxChange = (index) => {
    //     setSelectedRows(prevSelectedRows => {
    //         if (prevSelectedRows.includes(index)) {
    //             const prev = prevSelectedRows.filter(rowIndex => rowIndex !== index);
    //             return prev;

    //         } else {

    //             // const selectedRow = tableRows[index];

    //             // let rate = parseFloat(selectedRow.rate) || 0;
    //             // let qty = parseFloat(selectedRow.qty) || 0;
    //             // let amnt = (rate * qty).toFixed(2);
    //             // if (selectedRow.IGSTAmt !== '0') {
    //             //     var taxAmnt = selectedRow.IGSTAmt;
    //             //     var finalAmnt = parseFloat(taxAmnt) + parseFloat(amnt);
    //             // } else {
    //             //     taxAmnt = parseFloat(selectedRow.CGSTAmt) + parseFloat(selectedRow.SGSTAmt);
    //             //     finalAmnt = parseFloat(taxAmnt) + parseFloat(amnt);
    //             // }

    //             // setFormData({
    //             //     ...formData,
    //             //     tQtyM: qty,
    //             //     amt: amnt,
    //             //     taxAmt: taxAmnt,
    //             //     fAmt: finalAmnt,
    //             // });

    //             return [...prevSelectedRows, index];
    //         }
    //     });
    // };


    const handleAddButton = () => {
        setOpenBale(true);
    };

    const handleInputChanged = (index, field, value) => {
        if (field === 'mtr') {
            if (!/^\d*$/.test(value)) {
                return;
            }
        }
        setRows(prevRows => {
            const newRows = [...prevRows];
            newRows[index][field] = value;
            return newRows;
        });
    };

    const handleBaleSubmit = () => {
        const newData = rows.map((item) => (`${item.Id}||${item.bale}||${item.mtr}||${item.location}`));
        const inw_qty = [...rows.map((item) => parseFloat(item.mtr))] || [];
        const sum_inwQty = (inw_qty.reduce((sum, qty) => sum + qty, 0)).toFixed(2);

        const updatedRows = tableRows.map((ele, index) => {

            if (selectedRows.includes(index)) {
                const amnt = (parseFloat(ele.rate) * sum_inwQty).toFixed(2);
                if (ele.IGSTAmt !== '0') {
                    var igstAmt = ((parseFloat(ele.IGST) * amnt) / 100).toFixed(2) || 0;
                    var net_amt = parseFloat(amnt) + parseFloat(igstAmt);
                } else {
                    var cgstAmt = ((parseFloat(ele.CGST) * amnt) / 100).toFixed(2) || 0;
                    var sgstAmt = ((parseFloat(ele.SGST) * amnt) / 100).toFixed(2) || 0;
                    net_amt = parseFloat(amnt) + parseFloat(cgstAmt) + parseFloat(sgstAmt);
                }
                return {
                    ...ele,
                    details: newData,
                    netAmt: net_amt,
                    inwQty: sum_inwQty,
                    amount: amnt,
                    IGSTAmt: igstAmt || 0,
                    CGSTAmt: cgstAmt || 0,
                    SGSTAmt: sgstAmt || 0,
                };
            }
            return ele;
        });

        setTableRows(updatedRows);
        setOpenBale(false);
        const update_qty = [...updatedRows.map((val) => parseFloat(val.inwQty))] || [];
        const sum_updateQty = (update_qty.reduce((sum, qty) => sum + qty, 0)).toFixed(2);
        const updated_amt = [...updatedRows.map((val) => parseFloat(val.amount))] || [];
        const sum_updateAmt = (updated_amt.reduce((sum, amt) => sum + amt, 0)).toFixed(2);
        const update_igstAmt = [...updatedRows.map((val) => parseFloat(val.IGSTAmt))] || [];
        const sum_igstAmt = update_igstAmt.reduce((sum, igst) => sum + igst, 0);
        const update_cgstAmt = [...updatedRows.map((val) => parseFloat(val.CGSTAmt))] || [];
        const sum_cgstAmt = update_cgstAmt.reduce((sum, cgst) => sum + cgst, 0);
        const update_sgstAmt = [...updatedRows.map((val) => parseFloat(val.SGSTAmt))] || [];
        const sum_sgstAmt = update_sgstAmt.reduce((sum, sgst) => sum + sgst, 0);
        if (sum_igstAmt !== 0) {
            var taxAmt = (sum_igstAmt).toFixed(2);
        } else {
            taxAmt = (sum_cgstAmt + sum_sgstAmt).toFixed(2);
        }

        const final_amt = (parseFloat(sum_updateAmt) + parseFloat(taxAmt)).toFixed(2);
        setFormData(prevFormData => ({
            ...prevFormData,
            tQtyM: sum_updateQty,
            amt: sum_updateAmt,
            taxAmt: taxAmt,
            fAmt: final_amt
        }));

    };

    // function convertIntoOneObject(array, formData) {
    //     const tableData = {
    //         array: array,

    //         // Include formData fields
    //         partyNm: formData.partyNm,
    //         partyId: formData.vender,
    //         PoId: formData.PoId,
    //         dt: formData.dt,
    //         totqty: formData.totqty,
    //         PiNo: formData.PiNo,
    //         firmId: formData.firm,
    //         totamt: formData.totamt,
    //         totmtr: formData.totmtr,
    //         taxamt: formData.taxamt,
    //         finalamt: formData.finalamt,
    //         lrdt: formData.lrdt,
    //         lrno: formData.lrno,
    //         transpt: formData.transpt,
    //         bill: formData.bill,
    //         locId: formData.locId,
    //         userId: formData.userId
    //     };

    //     return tableData;
    // };

    function convertIntoOneObject(rows, formData) {

    const formattedRows = rows.map(r => ({
        matid: r.matId,
        pktqty: r.packetqty,
        perpacket: r.packets,
        qty: r.qty,
        rate: r.rate,
        amt: r.amount,

        igst: r.IGST,
        igstamt: r.IGSTAmt,
        cgst: r.CGST,
        cgstamt: r.CGSTAmt,
        sgst: r.SGST,
        sgstamt: r.SGSTAmt,

        mtr: r.mtr,
        inches: r.inches,
        totqty: r.totboxqty,

        inwqty: r.qty,
        inwmtr: r.mtr,
        inwInches: r.inches,
        inwtotqty: r.totboxqty,

        mtype: r.mtype,
        ptype: r.ptype
    }));


    return {
        array: formattedRows,

        partyId: formData.vender,
        PoId: formData.PoId,
        dt: formData.dt,
        totqty: formData.totqty,
        PiNo: formData.PiNo,
        firmId: formData.firm,
        totamt: formData.totamt,
        totmtr: formData.totmtr,
        taxamt: formData.taxamt,
        finalamt: formData.finalamt,
        lrdt: formData.lrdt,
        lrno: formData.lrno,
        transpt: formData.transpt,
        bill: formData.bill,
        locId: formData.locId,
        userId: formData.userId
    };
}
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const finalObject = convertIntoOneObject(tableRows, formData);
             console.log("finalobject",finalObject);

            const result = await axios.post(`${baseUrl}?apicall=insertMaterialPIDirectEntry`, finalObject);
            const data = result?.data;
            console.log(data);
            if (data.status === "success") {
                alert(data.msg);
                window.location.reload();
            } else {
                const msg = Array.isArray(data.msg) ? data.msg.join("\n") : data.msg;
                alert(msg);
            }
        } catch (error) {
            console.error('Error while making POST request:', error);
        } finally {
            setLoading(false);
        }

    };

    const handleResend = (resendData) => {
        // console.log("Received data from child window:", resendData);
        if (resendData) {
            const index = resendData?.index;
            const totmtr = resendData?.totmtr;
            const updateTableData = [...tableRows];

            let qty = updateTableData[index].qty;
            let inwQty = updateTableData[index].inwQty;
            let balQty = updateTableData[index].balQty;
            let rate = updateTableData[index].rate;

            inwQty = parseFloat(totmtr);
            balQty = parseFloat(qty) - parseFloat(totmtr);
            const amount = parseFloat(totmtr) * parseFloat(rate);

            updateTableData[index].inwQty = inwQty;
            updateTableData[index].balQty = balQty;
            updateTableData[index].amount = amount;

            const tQtyM = updateTableData.reduce((acc, qty) => acc + parseFloat(qty.inwQty), 0);
            const amt = updateTableData.reduce((acc, qty) => acc + parseFloat(qty.amount), 0);
            const famt = amt + parseFloat(formData.taxAmt);

            setTableRows(updateTableData);
            setFormData(prevFormData => ({
                ...prevFormData,
                tQtyM: tQtyM,
                amt: amt,
                fAmt: famt
            }));
        }
        // Process the data (e.g., update state)
    };

    window.handleResendFromChild = handleResend;

    const handleNavigateCloth = () => {
        window.open(`/new-material-entry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };
    const handleNavigateParty = () => {
        window.open(`/NewPartyEntry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };

    const dropdownlistfirst = [
        // {
        //     label: 'PO No.',
        //     id: 'PoId',
        //     options: mpolist?.data || [],
        //     value: formData.PoId,
        //     onChange: (newValue) => handleDropdownChange({ target: { name: 'PoId', value: newValue ? newValue.ID : '' } }, 'PoId'),
        //     getOptionLabel: (option) => option.pono || '',
        //     isOptionEqualToValue: (option, value) => option.ID === value.ID,
        //     valueFinder: (options, value) => {
        //         if (Array.isArray(options)) {
        //             return options.find(item => item.ID === value) || null;
        //         }
        //         return null;
        //     },
        // },
        {
            label: 'Material',
            id: 'matId',
            options: materialData || [],
            value: formData.matId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'matId', value: newValue ? newValue.ID : '' } }, 'matId'),
            getOptionLabel: (option) => option.materialNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: () => handleNavigateCloth(),
            btnlabel: 'New'
        },
        {
            label: 'Purchase Party',
            id: 'partyId',
            options: partyList?.data || [],
            value: formData.vender,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'vender', value: newValue ? newValue.ID : '' } }, 'vender'),
            getOptionLabel: (option) => option.partyNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: () => handleNavigateParty(),
            btnlabel: 'New',
        },
        {
            label: 'Firm',
            id: 'firmId',
            options: firmList?.data,
            value: formData.firm,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'firm', value: newValue ? newValue.ID : '' } }, 'firm'),
            getOptionLabel: (option) => option.firmNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        }
    ];



    const dropdownlistsecond = [
        {
            label: 'Transport',
            id: 'transpt',
            options: transptList?.data || [],
            value: formData.transpt,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'transpt', value: newValue ? newValue.transportNm : '' } }, 'transpt'),
            getOptionLabel: (option) => option.transportNm || '',
            isOptionEqualToValue: (option, value) => option.transportNm === value.transportNm,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.transportNm === value) || null;
                }
                return null;
            },
        },
        {
            label: 'Location',
            id: 'locId',
            options: loclist?.data || [],
            value: formData.locId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'locId', value: newValue ? newValue.locNm : '' } }, 'locId'),
            getOptionLabel: (option) => option.locNm || '',
            isOptionEqualToValue: (option, value) => option.locNm === value.locNm,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.locNm === value) || null;
                }
                return null;
            },
        }

    ];


    const handleDeleteRows = () => {
        const updated = tableRows?.filter((_, index) => !selectedRows.includes(index));
        const totalMeter = updated.reduce((total, row) => total + parseFloat(row.mtr || 0), 0);
        const totqty = updated.reduce((total, row) => total + parseFloat(row.totboxqty || 0), 0);
        const totalAmount = updated.reduce((total, row) => total + parseFloat(row.amount || 0), 0);
        const igstamt = updated.reduce((total, row) => total + parseFloat(row.IGSTAmt || 0), 0);
        const cgstamt = updated.reduce((total, row) => total + parseFloat(row.CGSTAmt || 0), 0);
        const sgstamt = updated.reduce((total, row) => total + parseFloat(row.SGSTAmt || 0), 0);
        const taxamt = igstamt + cgstamt + sgstamt;
        const finalAmt = taxamt + totalAmount;

        const updatedFormData = {
            ...formData,
            amt: totalAmount.toFixed(2),
            totmtr: totalMeter.toFixed(2),
            totqty: totqty.toFixed(2),
            taxAmt: taxamt.toFixed(2),
            fAmt: finalAmt.toFixed(2)
        };
        setTableRows(updated);
        setSelectedRows([]);
        setFormData(updatedFormData);
    };
    // console.log(onlyPonos?.data)
    return (
        <>
            <Titlebar data={materialPOMenu} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Direct Material Purchase Inward Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>


                                {
                                    dropdownlistfirst && dropdownlistfirst?.map((drop) => (
                                        <DropdownWithBtn
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                            btnlabel={drop.btnlabel}
                                            handleAddNew={drop.handleAddNew}
                                        />
                                    ))
                                }

                                {[
                                    { label: 'Total Qty', name: 'totqty', type: 'readOnly' },
                                    { label: 'Total Meter', name: 'totmtr', type: 'readOnly' },
                                    { label: 'PI No', name: 'PiNo' },
                                    { label: 'Amount', name: 'totamt', type: 'readOnly' },
                                    { label: 'Date', name: 'dt', type: 'date' },
                                    { label: 'Tax Amount', name: 'taxamt', type: 'readOnly' },
                                    { label: 'Final Amount', name: 'finalamt', type: 'readOnly' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.inputDate }}
                                                            sx={inputStyles}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name] || ''}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.type === 'readOnly' }}
                                                            sx={inputStyles}
                                                        />
                                                    )}

                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                {[
                                    { label: 'LR No', name: 'lrno' },
                                    { label: 'LR Date', name: 'lrdt', type: 'date' }

                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.inputDate }}
                                                            sx={inputStyles}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.name == 'PoNo' }}
                                                            sx={inputStyles}
                                                        />
                                                    )}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}


                                {[
                                    { label: 'Bill/Challan No', name: 'bill' }
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name] || ''}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input }}
                                                        sx={inputStyles}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}


                                {
                                    dropdownlistsecond && dropdownlistsecond?.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        />
                                    ))
                                }

                                <Grid item xs={12}>
                                    <Button variant="contained" color="secondary" onClick={handleDeleteRows} disabled={selectedRows.length === 0}>Delete</Button>
                                </Grid>
                                <Grid item xs={12}>
                                    <div>
                                        <TableContainer width={400}>
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Sr.No.</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Material</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Size</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>HSN</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>M.Qty</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.2, border: '1px solid #000' }} align='center'>P.P Qty/Mtr</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Delivery Date</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Rate</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Qty.</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Mtr.</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Inches</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Total Qty.</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Amount</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>IGST(%)</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>IGSTAmt</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>CGST(%)</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>CGSTAmt</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>SGST(%)</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>SGSTAmt</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {tableRows?.map((row, index) => {
                                                        {/* const isEditable = ['Mtr', 'Inch'].includes(row.mtype);
                                                                                      const isqtyEditable = ['Pcs', 'Box', 'Roll'].includes(row.mtype); */}

                                                        return (

                                                            <TableRow key={index}>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                    <Checkbox
                                                                        checked={selectedRows.includes(index)}
                                                                        onChange={() => handleCheckboxChange(index)}
                                                                    />
                                                                    {index + 1}
                                                                </TableCell>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                    {row.materialNm}
                                                                </TableCell>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                    {row.size}
                                                                </TableCell>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                    {row.hsn}
                                                                </TableCell>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>

                                                                    <input
                                                                        type='text'
                                                                        name="packetqty"
                                                                        value={row.packetqty}
                                                                        onChange={(e) => handleRowInputChange(index, e)}
                                                                        style={{ width: '50px', padding: '1px' }}
                                                                    />

                                                                    {" "}{row.mtype}
                                                                </TableCell>
                                                                <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>

                                                                    <input
                                                                        type='text'
                                                                        name="packets"
                                                                        value={row.packets}
                                                                        onChange={(e) => handleRowInputChange(index, e)}
                                                                        style={{ width: '50px', padding: '1px' }}
                                                                    />
                                                                    {" "} {row.ptype}
                                                                </TableCell>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                    <input
                                                                        type="date"
                                                                        name="deliveryDate"
                                                                        value={row.deliveryDate}
                                                                        onChange={(e) => handleRowInputChange(index, e)}
                                                                        style={{ width: '100px', padding: '1px' }}
                                                                    />
                                                                </TableCell>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                    <input
                                                                        type='text'
                                                                        name="rate"
                                                                        value={row.rate}
                                                                        onChange={(e) => handleRowInputChange(index, e)}
                                                                        style={{ width: '50px', padding: '1px' }}
                                                                    />
                                                                </TableCell>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                    <input
                                                                        type='text'
                                                                        name="qty"
                                                                        value={row.qty}
                                                                        // readOnly={!isqtyEditable}
                                                                        onChange={(e) => handleRowInputChange(index, e)}
                                                                        style={{ width: '50px', padding: '1px' }}
                                                                    />
                                                                </TableCell>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>


                                                                    {row.mtr}
                                                                </TableCell>

                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                    {row.inches}
                                                                </TableCell>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                    {row.totboxqty}
                                                                </TableCell>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>

                                                                    {row.amount}
                                                                </TableCell>

                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>


                                                                    <select name="IGST" value={row.IGST} onChange={(e) => handleRowInputChange(index, e)}>
                                                                        <option value="0">0</option>
                                                                        <option value="5">5</option>
                                                                        <option value="12">12</option>
                                                                        <option value="18">18</option>
                                                                         
                                                                    </select>
                                                                </TableCell>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>

                                                                    {row.IGSTAmt}
                                                                </TableCell>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>

                                                                    {row.CGST}
                                                                </TableCell>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>

                                                                    {row.CGSTAmt}
                                                                </TableCell>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>

                                                                    {row.SGST}
                                                                </TableCell>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>

                                                                    {row.SGSTAmt}
                                                                </TableCell>
                                                            </TableRow>
                                                        )
                                                    }
                                                    )}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                </Grid>


                                 <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading === true}>
                                        {
                                            loading === true ?
                                                <><CircularProgress size="20px" /> wait...</> :
                                                "Submit"
                                        }
                                    </Button>
                                </Grid>

                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>

            </div>
        </>
    );
}

export default DirectMatPIEntry;
